import { init, getCurrentScope, browserTracingIntegration, browserProfilingIntegration, captureConsoleIntegration } from "@sentry/react";
import { clearBreadcrumb, clearErrorEvent, clearTransaction } from "./filters";
import { bindDataForSend } from "./binds";
import { processConsoleEvent } from "./console";
import { isIgnoredException } from "./ignore";
import { isNoisyBreadcrumb } from "./journey";
const isIgnoredEvent = (event) => {
    const values = event.exception?.values ?? [];
    return values.some(({ type, value }) => isIgnoredException(type, value));
};
export const initSentry = () => {
    init({
        dsn: __SENTRY_DSN__,
        release: __RELEASE__,
        enabled: !!__SENTRY_DSN__,
        environment: __SENTRY_ENVIRONMENT__,
        maxBreadcrumbs: 100,
        integrations: [
            browserTracingIntegration(),
            browserProfilingIntegration(),
            captureConsoleIntegration({ levels: ['error'] })
        ],
        tracesSampleRate: 1,
        beforeSendTransaction: (event) => {
            clearTransaction(event);
            return event;
        },
        beforeBreadcrumb: (breadcrumbs) => {
            if (isNoisyBreadcrumb(breadcrumbs.category, breadcrumbs.message)) {
                return null;
            }
            clearBreadcrumb(breadcrumbs);
            return breadcrumbs;
        },
        beforeSend: (event) => {
            if (isIgnoredEvent(event)) {
                return null;
            }
            if (event.logger === 'console' && !processConsoleEvent(event)) {
                return null;
            }
            clearErrorEvent(event);
            bindDataForSend(event);
            return event;
        },
    });
    // меняем имя транзаций
    // ибо по умолчанию в ней идет конфидициальная инфа
    getCurrentScope().setTransactionName(window.location.host);
};
